<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="600px" content-class="select-dialog">
    <v-card>
      <v-card-title>
        <div class="title font-weight-light">選択してください</div>
      </v-card-title>
      <v-card-title v-if="items.length > 10">
        <v-text-field outlined dense
          v-model="keyword"
          placeholder=" "
          prepend-icon="fas fa-search"
          label="検索するキーワードを入力してください。"
          hide-details="auto"></v-text-field>
      </v-card-title>
      <v-card-text class="dialog-body">
        <ul class="select-item">
          <li v-for="item in filterItems" :key="item.value" @click="closeSelected(item)">{{ item.text ? item.text : item }}</li>
        </ul>
      </v-card-text>
      <v-card-actions class="pa-5" v-if="add">
          <v-text-field label="新しい項目名" v-model="newItem" outlined hide-details dense></v-text-field>
          <v-spacer></v-spacer>
          <v-btn @click="closeSelected(newItem)" :disabled="!newItem">
            追加する
          </v-btn>
      </v-card-actions>
      <v-card-actions class="dialog-footer">
        <v-spacer></v-spacer>
        <v-btn @click="close" depressed>
          <v-icon left>fas fa-times</v-icon>閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
      keyword: null,
      newItem: null,
    }
  },
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    show: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  created() {},
  computed: {
    filterItems() {
      const map = []
      this.items.forEach(e => {
        if (this.keyword) {
          if (e.text && e.text.indexOf(this.keyword) === -1) {
            return
          } else if (e.indexOf && e.indexOf(this.keyword) === -1) {
            return
          }
        }
        map.push(e)
      })
      return map
    }
  },
  watch: {
    show(val) {
      this.dialog = val
    },
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    close() {
      this.keyword = null
      this.newItem = null
      this.closeSelected(null)
      //this.dialog = false
      //this.$emit('closePreview', this.report.sign)
    },
  },
}
</script>

<style scoped>
.dialog-body {
  padding: 20px !important;
}
.select-item {
  list-style: none;
  padding: 0;
  margin: 0;
}
.select-item li {
  padding: 10px;
  border: 1px solid #CCC;
  border-radius: 5px;
  margin-bottom: 5px;
}
.select-item li:hover {
  cursor: pointer;
  background-color: #DCEDC8;
}
</style>
